var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"kteIdentity"},[_c('img',{attrs:{"src":require("assets/img/kube-logo.svg"),"alt":"Kube Partners"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.identityText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }